var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37501 7.49984C4.3751 4.39331 6.89346 1.875 10 1.875C13.1066 1.875 15.625 4.3934 15.625 7.5L15.6248 7.54099V8.125C15.6248 9.89427 16.2924 11.5062 17.3903 12.7249C17.5291 12.8789 17.5824 13.0917 17.5328 13.293C17.4831 13.4942 17.3369 13.6578 17.1424 13.7296C15.8557 14.2045 14.5088 14.5549 13.1164 14.766C13.1221 14.8433 13.125 14.9213 13.125 15C13.125 16.7259 11.7259 18.125 10 18.125C8.27412 18.125 6.87501 16.7259 6.87501 15C6.87501 14.9214 6.87793 14.8433 6.88367 14.766C5.49111 14.5549 4.14406 14.2046 2.85729 13.7296C2.66282 13.6578 2.5166 13.4942 2.46694 13.293C2.41728 13.0917 2.47064 12.8789 2.60939 12.7249C3.70733 11.5062 4.37484 9.89427 4.37484 8.125L4.37501 7.49984ZM8.12684 14.9161C8.12563 14.9439 8.12501 14.9718 8.12501 15C8.12501 16.0355 8.96448 16.875 10 16.875C11.0355 16.875 11.875 16.0355 11.875 15C11.875 14.9718 11.8744 14.9438 11.8732 14.916C11.256 14.9716 10.6312 15 9.99985 15C9.36863 15 8.74389 14.9716 8.12684 14.9161Z",
    fill: "#2D3643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.721e9ae0b8e0172e8f720415dc227a00.svg";
export { ForwardRef as ReactComponent };